module.exports = __webpack_public_path__ + "img/case-szwgyxx.48c55731.png";